import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTableRest } from '../tableService';
import { TableState } from '../tableState';
interface GetTableQueryResponse {
  data: TableState;
}

const useGetTableRest = (tableId: string, tableUrl?: string): UseQueryResult<GetTableQueryResponse, Error> => {
  return useQuery<GetTableQueryResponse, Error>({
    queryKey: ['table-rest', tableId, tableUrl],
    queryFn: async () => {
      const response = await getTableRest({ tableId, tableUrl });
      return { data: { ...response.data, tableId } };
    },
  });
};

export default useGetTableRest;
